// Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved.

function parseTsv(text: string): string[][];
function parseTsv(text: string | null): string[][] | null;
function parseTsv(text: string | null) {
  if (!text) {
    return null;
  }
  const clean = text.replace(/^\uFEFF/, '');
  const lines = clean.split(/\r?\n/).filter(l => l.length > 0);
  return lines
    .map(line => line.split('\t'))
    .filter(cols => cols.length > 0)
    .map(cols => cols.map(col => col.trim()));
}

export const TsvUtil = {
  parse: parseTsv,
} as const;
